import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

const Loading = ({ active = true }) => (
  <Dimmer active={active}>
    <Loader content="Loading..." />
  </Dimmer>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js